<template>
  <ProductRow 
    :sku="item.sku"
    :item="item"
    :itemName="item.name"
    :imgUrl="item.img_url"
    icon="fas fa-shopping-basket">

    <template v-slot:headerContent>
      <div v-if="!item.is_active" class="col-4">
        <span  class="badge badge-danger ml-2">Inactive</span>
      </div>
    </template>

    <p v-if="item.original_price !== item.price" class="strikethrough mr-1 mb-0 text-success">{{ formatDollars(item.original_price) }}</p>
    <div class="d-flex flex-column flex-xxl-row align-items-start align-items-xxl-end ">
      <div class="mr-2 my-2 price-input" v-if="!item.is_bundle">
        <input v-if="editMode" v-model="editedPrice" ref="priceEditField" type="number" class="form-control h-100 custom-form-inline"
                @keydown.enter="updatePrice"
                @focusout="updatePrice"
                @keydown.esc="resetPrice">
        <jet-button v-else @click="editPrice" icon="fas fa-pencil-alt" btnStyle="secondary" class="btn-sm">
          {{ formatDollars(item.price) }}
        </jet-button>
      </div>

      <Quantity
        :item="item"
        @quantityChanged="(e) => this.$emit('quantityChanged', item, e.target.value)"
        @deleteItem="() => this.$emit('deleteItem', item)"
        @increment="() => this.$emit('increment', item)"
        @decrement="() => this.$emit('decrement', item)"
      />
    </div>

    <template v-slot:priceInfo>
      <h5 class="text-success mb-0">{{ formatDollars(item.price * item.qty) }}</h5>
    </template>
  </ProductRow>
</template>

<script>
  import Quantity from '@/Shared/Quantity'
  import JetButton from '@/Jetstream/Button'
  import ProductRow from '@/Components/Shop/ProductRow'

  export default {
    components: {
      Quantity,
      JetButton,
      ProductRow,
    },
    props: {
      item: Object,
    },
    data() {
      return {
        editedPrice: this.item.price,
        editMode: false,
      };
    },
    methods: {
      editPrice() {
        this.editMode = true;
        this.$nextTick(() => this.$refs.priceEditField.focus());
      },
      updatePrice() {
        this.editMode = false;
        if (this.item.price != this.editedPrice)
        {
          this.item.price = this.editedPrice;
          this.$emit('setPrice', this.item, this.editedPrice);
        }
      },
      resetPrice() {
        this.editMode = false;
        this.editedPrice = this.item.price;
      }
    }
  }
</script>
